import {post, get} from '@/lib/axios';

const database = {
  async get_classification() {
    return get(`/database/classification`);
  },
  async classification_get_by_id(id) {
    return get(`/database/classification/${id}`);
  },
  async get_oem() {
    return get(`/database/oem`);
  },
  async oem_get_by_id(id) {
    return get(`/database/oem/${id}`);
  },
  async get_products() {
    return get(`/database/products`);
  },
  async products_get_by_id(id) {
    return get(`/database/products/${id}`);
  },
  async get_glossary() {
    return get(`/database/glossary`);
  },
  async glossary_get_by_id(id) {
    return get(`/database/glossary/${id}`);
  },
  async search_database(phrase) {
    return get(`/database/search`, {phrase});
  },
};
export {database as default};
